<main>
  <div class="body-login">
    <div class="container mt-5">
      <section aria-labelledby="boas-vindas">
        <img id="boas-vindas" [src]="'assets/home/judsaude.svg'" class="w-100 img-judsaude" alt="Imagem Jud Saúde" />
        <div class="card-container">
          <app-card-icon [svgIcon]="'file-list'" [description]="'Visualizar Notas Técnicas'" role="button" tabindex="0"
            aria-label="Visualizar Notas Técnicas" (click)="navegarParaNotaTecnica()"></app-card-icon>
          <app-card-icon [svgIcon]="'authenticity'" [description]="'Conferir Autenticidade de Notas Técnicas'"
            role="button" tabindex="0" aria-label="Conferir Autenticidade de Notas Técnicas" (click)="navegarParaVerificarAutenticidade()"
          ></app-card-icon>
          <app-card-icon [svgIcon]="'lock'" [description]="'Acessar Área Restrita'" role="button" tabindex="0"
            aria-label="Acessar Área Restrita" (click)="navegarParaLogin()"></app-card-icon>
          <app-card-icon [svgIcon]="'question'" [description]="'Dúvidas Frequentes'" role="button" tabindex="0"
            aria-label="Dúvidas Frequentes" (click)="verSaibaMais()"
            *ngIf="saibaMaisItems && saibaMaisItems.length > 0"></app-card-icon>
        </div>
      </section>
      <section class="mt-5">
        <mat-card class="carousel-container" *ngIf="hasBanners && banners.length > 0">
          <a *ngIf="hasBanners && banners.length > 0" [href]="getCurrentSlideLink()" target="_blank" rel="noopener">
            <img [src]="getCurrentSlideImage()" class="carousel-img" alt="Banner" />
          </a>
        </mat-card>
        <div class="carousel-indices">
          <ng-container *ngIf="hasBanners && banners.length > 0">
            <span *ngFor="let banner of banners; let i = index" [class.active]="i === currentSlide"
              (click)="goToSlide(i)" tabindex="0"
              (keyup)="($event.key === 'Enter' || $event.key === ' ') && goToSlide(i)">
            </span>
          </ng-container>
        </div>
      </section>
      <hr class="hr-color mt-5 mb-5">
      <section aria-labelledby="experimente-ia" class="section-ia mb-0">
        <div class="coluna-1">
          <h2 id="experimente-ia">Experimente a nossa Inteligência Artificial</h2>
          <h3 class="mb-4">Agora ficou mais fácil para você encontrar as notas técnicas com a inteligência
            artificial do portal de Judicialização.</h3>
          <div class="container mb-3 p-0">
            <div class="ia-group">
              <input type="text" class="form-control custom-input"
                placeholder="Pergunte para a nossa inteligência artificial ..."
                aria-label="Campo para iniciar chat com a inteligência artificial" (click)="openChat()" tabindex="0"
                (keyup)="onKeyup($event)" readonly>
            </div>
          </div>
        </div>
        <div class="coluna-2">
          <img [src]="'assets/home/ia-gif.gif'" alt="Descrição da animação" width="198" height="204">
        </div>
      </section>
      <section aria-labelledby="saiba-mais" *ngIf="saibaMaisItems && saibaMaisItems.length > 0">
      <hr class="hr-color mt-5 mb-5">
        <img [src]="'assets/home/saiba-mais.svg'" class="w-100 img-saiba-mais" id="saiba-mais" #sessaoSaibaMais
          alt="Imagem Banner Saiba Mais" />
        <app-accordion [items]="saibaMaisItems"></app-accordion>
      </section>
      <section aria-labelledby="link-util" *ngIf="linksUteisItems && linksUteisItems.length > 0">
      <hr class="hr-color mt-5 mb-5">
        <img [src]="'assets/home/link-util.svg'" class="w-100 img-link-util" id="link-util"
          alt="Imagem Banner Links Úteis" />
        <section class="mt-5 mb-5" *ngIf="slidesLinks && slidesLinks.length > 0">
          <div class="carousel-viewport">
            <div class="carousel-track" [style.transform]="getTransform()">
              <mat-card class="logo-card" *ngFor="let slide of infiniteSlides">
                <a [href]="slide.link" target="_blank">
                  <img [src]="slide.image" alt="Logo" />
                </a>
              </mat-card>
            </div>
          </div>
          <div class="carousel-indices-links">
            <span *ngFor="let group of slideGroups; let i = index" [class.active]="i === currentSlideLink"
              (click)="goToSlideLinks(i)" tabindex="0"
              (keyup)="($event.key === 'Enter' || $event.key === ' ') && goToSlideLinks(i)">
            </span>
          </div>
        </section>
        <app-accordion-link [items]="linksUteisItems"></app-accordion-link>
      </section>
    </div>
    <div class="img-back"></div>
  </div>
</main>